import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API_URL } from "@/data/content";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Google OAuth callback: URL fragment carries session_id — exchange it first.
    if (window.location.hash.includes("session_id=")) {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const sid = window.location.hash.split("session_id=")[1]?.split("&")[0] || "";
      axios
        .post(`${API_URL}/auth/google`, { session_id: sid }, { withCredentials: true })
        .then(({ data }) => {
          setUser(data);
          toast.success(`Welcome home, ${data.name.split(" ")[0]}!`);
        })
        .catch(() => {
          setUser(false);
          toast.error("Google sign-in could not be completed");
        })
        .finally(() => window.history.replaceState(null, "", window.location.pathname + window.location.search));
      return;
    }
    axios
      .get(`${API_URL}/auth/me`, { withCredentials: true })
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const logout = async () => {
    try {
      await axios.post(`${API_URL}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {
      /* ignore */
    }
    setUser(false);
    toast.success("Signed out — farewell from Chandbagh");
  };

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
